import React from 'react';
import DateCell from './DateCell';

const CalendarGrid = ({ currentDate, events, onEventClick, onDateClick }) => {
  const getDaysInMonth = (date) => {
    const year = date?.getFullYear();
    const month = date?.getMonth();
    return new Date(year, month + 1, 0)?.getDate();
  };

  const getFirstDayOfMonth = (date) => {
    const year = date?.getFullYear();
    const month = date?.getMonth();
    return new Date(year, month, 1)?.getDay();
  };

  const daysInMonth = getDaysInMonth(currentDate);
  const firstDay = getFirstDayOfMonth(currentDate);
  const today = new Date();
  
  const calendarDays = [];
  
  // Add empty cells for days before the first day of the month
  for (let i = 0; i < firstDay; i++) {
    calendarDays?.push(null);
  }
  
  // Add cells for each day of the month
  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(currentDate?.getFullYear(), currentDate?.getMonth(), day);
    const dayEvents = events?.filter(event => {
      const eventDate = event?.date;
      return eventDate?.getDate() === day && 
             eventDate?.getMonth() === currentDate?.getMonth() && 
             eventDate?.getFullYear() === currentDate?.getFullYear();
    });
    
    const isToday = date?.getDate() === today?.getDate() && 
                    date?.getMonth() === today?.getMonth() && 
                    date?.getFullYear() === today?.getFullYear();
    
    calendarDays?.push({
      day,
      date,
      events: dayEvents,
      isToday
    });
  }

  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  return (
    <div className="calendar-grid">
      {/* Week day headers */}
      <div className="grid grid-cols-7 gap-2 mb-2">
        {weekDays?.map((day, index) => (
          <div 
            key={index} 
            className="text-center text-sm font-semibold text-muted-foreground py-2"
          >
            <span className="hidden md:inline">{day}</span>
            <span className="md:hidden">{day?.substring(0, 1)}</span>
          </div>
        ))}
      </div>

      {/* Calendar grid */}
      <div className="grid grid-cols-7 gap-2">
        {calendarDays?.map((dayData, index) => (
          <DateCell
            key={index}
            dayData={dayData}
            onEventClick={onEventClick}
            onDateClick={onDateClick}
          />
        ))}
      </div>
    </div>
  );
};

export default CalendarGrid;